import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import InternationalPreviewService from './services/InternationalPreviewService'

export const getInternationalCompanyDetail = createAsyncThunk(
  'internationalSearch/preview/GET_INTERNATIONAL_COMPANY',
  async (data, { rejectWithValue }) => {
    try {
      const response = await InternationalPreviewService.getCompanyDetail(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getProducts = createAsyncThunk(
  'internationalSearch/preview/GET_INTERNATIONAL_PRODUCT',
  async (data, { rejectWithValue }) => {
    try {
      const response = await InternationalPreviewService.getProducts(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getOrderRequest = createAsyncThunk(
  'internationalSearch/preview/GET_ORDER_REQUEST',
  async (data, { rejectWithValue }) => {
    try {
      const response = await InternationalPreviewService.getOrderRequest(data)
      if (response.success) {
        return response.data
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
